baseRun.$inject = [
  '$rootScope',
  '$log',
  '$location',
  '$injector',
  'i18nFilter',
];

export function baseRun(
  $rootScope,
  $log,
  $location,
  $injector,
  i18nFilter
) {
  // start / finish loading shows the loader after a delay !
  var startLoadingTimer = null;

  app.startPerfTimer = angular.noop;
  app.resetPerfTimer = angular.noop;
  app.stopPerfTimer = angular.noop;

  /**
   * Shows the "Bitte warten" dialog. If an eventName (could be any string) is
   * provided, the dialog is not show. Instead of the dialog an event ist
   * fired with this eventName. The value of the event is true. The
   * directives: loadingBroadcastHint and showOnLoading are aware of this
   * event. You may use grid-loading as a possible event name. In this case a
   * loading indicator blocks only the grid if data needs to be loaded.
   */
  app.startLoading = startLoading;

  /**
   * Hides the "Bitte warten" dialog. If an eventName (could be any string) is
   * provided, an event ist fired with this eventName. The value of the event
   * is false. The directives: loadingBroadcastHint and hideOnLoading are
   * aware of this event.
   */
  app.finishLoading = finishLoading;

  app.showLoader = showLoader;

  app.hideLoader = hideLoader;

  app.invokeAngular = invokeAngular;

  app.registerPerfTimers = registerPerfTimers;

  // go to another location and give a backlink
  app.gotoWithBackButton = gotoWithBackButton;

  app.hasRight = hasRight;

  app.clearCache = clearCache;

  app.hasRightToCurrentRoute = hasRightToCurrentRoute;

  enhanceRootScope();
  init();

  /* Performance timers, enable only for debugging purpose */
  // registerPerfTimers();

  function enhanceRootScope() {
    enums.load(i18nFilter);
    $rootScope.enums = enums;

    $rootScope.credentials = app.credentials;
    $rootScope.$log = $log;

    /* Adds a reference to the rootscope so it can be references in Templates via {{$rootscope.somedata}} instead of
         just using {{somedata}} which may result in overshadowing variables. */
    $rootScope.$rootScope = $rootScope;

    $rootScope.modalOptions = {
      backdropFade: true,
      dialogFade: true,
      extraScope: true
    }; // default modal options, todo refactor

    $rootScope.goto = function(path) {
      console.debug('goto ' + path);
      $location.path(path);
    };
    $rootScope.Math = window.Math;

    $rootScope.goBackStateFinished = goBackStateFinished;
  }

  function init() {
    // set loading message . We cannot set this via an angular directive as the app is not loaded at that point..
    $('#loadingText').text(i18nFilter('fe.common.pleaseWait', 'Bitte warten'));
  }

  function registerPerfTimers() {
    var perf = {};
    app.startPerfTimer = function(name, title) {
      if (!title) title = name;
      perf[name] = {
        times: [new Date().getTime()],
        title: title
      };
    };
    app.resetPerfTimer = function(name) {
      if (perf[name]) perf[name].times.push(new Date().getTime());
    };
    app.stopPerfTimer = function(name) {
      if (perf[name]) {
        var data = perf[name];

        data.times.push(new Date().getTime());
        var overallDif = 0;
        var timeStr = '';
        var lastTime = null;
        $.each(data.times, function(k, time) {
          if (!lastTime) lastTime = time;
          else {
            var timeDif = time - lastTime;
            timeStr += '(' + timeDif + ')';
            lastTime = time;
            overallDif += timeDif;
          }
        });

        if (data.times.length > 2) timeStr += '=' + overallDif;
        else timeStr = overallDif;

        if (overallDif > 2000) {
          console.error(
            'Performance >2s :' + data.title + ' ' + timeStr + 'ms'
          );
        } else if (overallDif > 1000) {
          console.warn('Performance >s :' + data.title + ' ' + timeStr + 'ms');
        } else if (overallDif > 300) {
          console.log(
            'Performance >300ms :' + data.title + ' ' + timeStr + 'ms'
          );
        }
        perf[name] = null;
      }
    };
  }

  function startLoading(hysteresisInMs, loadingBroadcastEventName) {
    if (loadingBroadcastEventName) {
      $rootScope.$broadcast(loadingBroadcastEventName, true);
      return;
    }
    if (!hysteresisInMs) {
      hysteresisInMs = 800;
    }

    if (startLoadingTimer !== null) return; // don't show the loader again
    app.startPerfTimer('loading');
    startLoadingTimer = setTimeout(function() {
      startLoadingTimer = null;
      showLoader();
    }, hysteresisInMs);
  }

  function finishLoading(loadingBroadcastEventName) {
    if (loadingBroadcastEventName) {
      $rootScope.$broadcast(loadingBroadcastEventName, false);
      return;
    }
    if (startLoadingTimer != null) {
      clearTimeout(startLoadingTimer);
      startLoadingTimer = null;
    }
    app.stopPerfTimer('loading');
    hideLoader();
  }

  function showLoader() {
    app.startPerfTimer('loader');
    $('#loadingDiv').show(); //fadeIn("fast");
  }

  function hideLoader() {
    app.stopPerfTimer('loader');
    $('#loadingDiv').hide(); //fadeOut("fast");
  }

  function invokeAngular(func) {
    ang.apply($rootScope, function() {
      $injector.invoke(func);
    });
  }

  function gotoWithBackButton(location, backlink, title, type, data) {
    var before = $rootScope.goBackState;
    var locationBefore = location;
    var newLoc = app.getBacklinkRoute(location);
    if (newLoc) {
      location = newLoc;
    }
    if (backlink) {
      newLoc = app.getBacklinkRoute(backlink);
      if (newLoc) {
        backlink = newLoc;
      }
    }

    console.debug(
      'goWithBackButton',
      locationBefore + '->' + location,
      backlink
    );
    $rootScope.goBackState = {
      title: title,
      type: type,
      data: data,
      backlink: backlink,
      before: before
    };

    $rootScope.goto(location);
  }

  function goBackStateFinished(key, defaultValue) {
    if (key) {
      $rootScope.alertController.addTemporaryAlert(
        i18nFilter(key, defaultValue),
        'success'
      );
    }
    if ($rootScope.goBackState) {
      $rootScope.goBackState = $rootScope.goBackState.before; // i did go back
    } else {
      $rootScope.goBackState = null; // i did go back !
    }
  }

  function checkSingleRight(right) {
    var hasRight = false,
      rights = app.credentials.rights;
    if (rights && rights.length > 0) {
      for (var i = 0; i < rights.length; i++) {
        if (rights[i].toLowerCase() == right.toLowerCase()) {
          hasRight = true;
          break;
        }
      }
    }
    return hasRight;
  }

  function hasRight(right) {
    // CFNPOC-6181
    // multiple rights are separated by comma
    var rightsArray = right.split(',');

    var hasRight = true;

    for (var i = 0; i < rightsArray.length; i++) {
      var currentRight = rightsArray[i].trim();
      hasRight = hasRight && checkSingleRight(currentRight);

      if (!hasRight) {
        break;
      }
    }

    return hasRight;
  }

  function clearCache() {
    // For some reason using $http here takes a really long time to execute the request, so we use $.ajax.
    // This Rest call works, but does not execute in live mode.
    return $.ajax({
      url: '/365FarmNet/rest/dev/cache/empty',
      method: 'POST',
      headers: {
        'X-XSRF-TOKEN': getCookie('XSRF-TOKEN')
      }
    });
  }

  function hasRightToCurrentRoute() {
    var path = $location.path();
    var matchedPath;

    if (app.credentials && app.credentials.loggedIn) {
      matchedPath = _.find(Object.keys(app.routeRights), function(route) {
        var regexp = pathRegExp(route);
        return (
          regexp.test(path) || regexp.test(path.substr(0, path.length - 1))
        );
      });

      if (matchedPath) {
        // Path-match?
        return hasRight(app.routeRights[matchedPath]);
      }
    }

    return true;
  }

  //from angular-route.js
  function pathRegExp(path) {
    var prepareRegExp = path
      .replace(/([().])/g, '\\$1')
      .replace(/(\/)?:(\w+)(\*\?|[\?\*])?/g, function(_, slash, key, option) {
        var optional = option === '?' || option === '*?' ? '?' : null;
        var star = option === '*' || option === '*?' ? '*' : null;
        slash = slash || '';
        return (
          '' +
          (optional ? '' : slash) +
          '(?:' +
          (optional ? slash : '') +
          ((star && '(.+?)') || '([^/]+)') +
          (optional || '') +
          ')' +
          (optional || '')
        );
      })
      .replace(/([\/$\*])/g, '\\$1');

    return new RegExp('^' + prepareRegExp + '$', '');
  }
}
